import { BROKER_CONNECT_ACTION_TYPES } from '../../constants/actionTypes/brokerConnectTypes';
import API from '../../services/API';

import { setError, startSpinner, stopSpinner } from '../common/actionCreators';
 
export const setBrokerConnectData = payload => ({
    type: BROKER_CONNECT_ACTION_TYPES.SET_BROKERCONNECT_DATA,
    payload
});


export const setBrokerConnectDataWithoutSave = payload => ({
    type: BROKER_CONNECT_ACTION_TYPES.SET_BROKERCONNECT_DATA_WITHOUT_SAVE,
    payload
});


/************************

 # Async action creators

 ************************/  

const actions = { setError, startSpinner, stopSpinner };

export const fetchBrokerConnectData = url => async dispatch => {
    const data = await API.getData(url, dispatch, actions);

    if(data) {
        dispatch(setBrokerConnectData(data));
    } else {
        console.error('there is an error in fetchBrokerConnectData');
    }
};

export const updateBrokerConnectData = ( url, payload ) => async dispatch => {
    const params = [url, payload, undefined, false ];
    const data = await API.postData(params, dispatch, actions);

    if(data) {
        dispatch(setBrokerConnectData(data));
    } else {
        console.error('there is an error in updateBrokerConnectData');
    }
};

export const updateBrokerConnectDataWithoutSave = payload => async dispatch => {
    dispatch(setBrokerConnectDataWithoutSave(payload));
};
